// extracted by mini-css-extract-plugin
export var clutchFixed = "StickyWidget-module--clutch-fixed--422b7";
export var clutchWidget = "StickyWidget-module--clutch-widget--604ea";